import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  static targets = ["select"]
  static values = {
    options: Object
  }

  connect() {
    const options = { plugins: ['remove_button'], maxOptions: null, clearAfterSelect: true }

    this.tom = new TomSelect(this.selectTarget, options)
  }

  disconnect() {
    if (this.tom) {
      this.tom.destroy()
    }
  }

  selectAll() {
    if (!this.selectTarget.multiple || !this.tom) return

    const values = Array.from(this.selectTarget.options).map(option => option.value)
    this.tom.setValue(values)
  }

  clearAll() {
    if (!this.tom) return

    this.disconnect()
    this.connect()
  }
}
